// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UsageDayCycleResponse implements flatbuffers.IUnpackableObject<UsageDayCycleResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageDayCycleResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageDayCycleResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDayCycleResponse,
  ): UsageDayCycleResponse {
    return (obj || new UsageDayCycleResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsUsageDayCycleResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDayCycleResponse,
  ): UsageDayCycleResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageDayCycleResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  category(): string;
  category(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  category(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  count(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  hours(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startUsageDayCycleResponse(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addCategory(builder: flatbuffers.Builder, categoryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, categoryOffset, 0);
  }

  static addCount(builder: flatbuffers.Builder, count: number) {
    builder.addFieldInt32(1, count, 0);
  }

  static addHours(builder: flatbuffers.Builder, hours: number) {
    builder.addFieldInt16(2, hours, 0);
  }

  static endUsageDayCycleResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // category
    return offset;
  }

  static createUsageDayCycleResponse(
    builder: flatbuffers.Builder,
    categoryOffset: flatbuffers.Offset,
    count: number,
    hours: number,
  ): flatbuffers.Offset {
    UsageDayCycleResponse.startUsageDayCycleResponse(builder);
    UsageDayCycleResponse.addCategory(builder, categoryOffset);
    UsageDayCycleResponse.addCount(builder, count);
    UsageDayCycleResponse.addHours(builder, hours);
    return UsageDayCycleResponse.endUsageDayCycleResponse(builder);
  }

  unpack(): UsageDayCycleResponseT {
    return new UsageDayCycleResponseT(this.category(), this.count(), this.hours());
  }

  unpackTo(_o: UsageDayCycleResponseT): void {
    _o.category = this.category();
    _o.count = this.count();
    _o.hours = this.hours();
  }

  unpackFields(...fields: string[]): UsageDayCycleResponseT {
    const t = new UsageDayCycleResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("category")) {
      t.category = this.category();
    }
    if (fieldSet.has("count")) {
      t.count = this.count();
    }
    if (fieldSet.has("hours")) {
      t.hours = this.hours();
    }
    return t;
  }
}

export class UsageDayCycleResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public category: string | Uint8Array | null = null,
    public count: number = 0,
    public hours: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.category === null || this.category === undefined) {
      throw new Error('Required field "category" is not set');
    }
    const category = this.category !== null ? builder.createString(this.category!) : 0;

    return UsageDayCycleResponse.createUsageDayCycleResponse(
      builder,
      category,
      this.count,
      this.hours,
    );
  }

  clone(): UsageDayCycleResponseT {
    const obj = new UsageDayCycleResponseT();
    obj.category = this.category;
    obj.count = this.count;
    obj.hours = this.hours;
    return obj;
  }

  equals(other: UsageDayCycleResponseT): boolean {
    if (this.category !== other.category) return false;
    if (this.count !== other.count) return false;
    if (this.hours !== other.hours) return false;
    return true;
  }
}

export function verifyUsageDayCycleResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "category");
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 2);
  } finally {
    verifier.popDepth();
  }
}
